import {Utilities} from '@shared/utilities/utilities.model';
import {CheckPreEvaluationModel} from '@cc-commons/models/check-pre-evaluation.model';
import {CountriesListModel} from '@shared/models/countries-list.model';
import {OfficeAddressModel, OfficeDerogationModel} from "@cc-commons/models/esb-contract.model";
import {CalculateReturn} from '@cc-dekra-backoffice/models/cc-dk-bo.models';

export class ContractDetailsModel {
    public static APPOINTMENT_REQUIRED = 'APPOINTMENT_REQUIRED'; //pr disponibilità
    public static APPOINTMENT_REQUIRED_ID = 10;
    public static APPOINTMENT_CONFIRMED = 'APPOINTMENT_CONFIRMED'; //pr ora
    public static APPOINTMENT_CONFIRMED_ID = 20;
    public static READY_FOR_SURVEY = 'READY_FOR_SURVEY';
    public static READY_FOR_SURVEY_ID = 30;
    public static WITH_SURVEY = 'WITH_SURVEY';
    public static WITH_SURVEY_ID = 40;
    public static CLOSED = 'CLOSED';
    public static CLOSED_ID = 50;
    public static REBILLABLE = 'REBILLABLE';
    public static REBILLABLE_ID = 60;
    public static REBILLABLE_IN_WORKING = 'REBILLABLE_IN_WORKING';
    public static REBILLABLE_IN_WORKING_ID = 70;
    public static REBILLABLE_IN_REVIEW = 'REBILLABLE_IN_REVIEW';
    public static REBILLABLE_IN_REVIEW_ID = 80;
    public static REBILLABLE_CLOSED = 'REBILLABLE_CLOSED';
    public static REBILLABLE_CLOSED_ID = 90;
    public static NO_SHOW = 'NO_SHOW';
    public static NO_SHOW_ID = 0;
    public static CANCELED = 'CANCELED';
    public static CANCELED_ID = 100;

    public static CLOSURE_WITH_SURVEYOR = 'CLOSURE_WITH_SURVEYOR';
    public static CLOSURE_WITHOUT_SURVEYOR = 'CLOSURE_WITHOUT_SURVEYOR';
    public static CLOSURE_WITH_TEMPLATE = 'CLOSURE_WITH_TEMPLATE';
    public static CLOSURE_WITH_TEMPLATE_WITH_SURVEYOR = 'CLOSURE_WITH_TEMPLATE_WITH_SURVEYOR';

    public static TOTAL_LOSS = 'TOTAL LOSS';
    public static TOTAL_LOSS_ID = '100446';
    public static MODULO_CONTRATTO_SCADUTO = 'MODULO CONTRATTO SCADUTO';
    public static MODULO_CONTRATTO_SCADUTO_ID = '402357';
    public static PAYMENT_DEFAULT_OR_BANKRUPTCY = 'PAYMENT DEFAULT OR BANKRUPTCY';
    public static PAYMENT_DEFAULT_OR_BANKRUPTCY_ID = '100471';
    public static VETTURA_DIFFORME = 'VETTURA DIFFORME';
    public static VETTURA_DIFFORME_ID = '402236';
    public static THEFT = 'THEFT';
    public static THEFT_ID = '100447';
    public static FAILURE = 'FAILURE';
    public static FAILURE_ID = '402611';
    public static POOL_MIDTERM = 'Pool Midterm';
    public static POOL_MIDTERM_ID = '403694';
    public static RIENTRO_DA_FURTO = 'Rientro da Furto';
    public static RIENTRO_DA_FURTO_ID = '404172';
    public static RIENTRO_DA_FALLIMENTO = 'Rientro da Fallimento';
    public static RIENTRO_DA_FALLIMENTO_ID = '404190';
    public static APPROPRIAZIONI_INDEBITE = 'Appropriazioni indebite';
    public static APPROPRIAZIONI_INDEBITE_ID = '404191';
    public static RIENTRO_APPROPRIAZIONI_INDEBITE = 'Rientro da appropriazione indebita';
    public static RIENTRO_APPROPRIAZIONI_INDEBITE_ID = '404192';
    public static CONTRATTO_SCADUTO_MECCANICA = 'Contratto Scaduto Meccanica';
    public static CONTRATTO_SCADUTO_MECCANICA_ID = '404193';
    public static NORMAL_CLOUSER_EARLY_TERMINATION = 'NORMAL CLOSURE / EARLY TERMINATION';
    public static NORMAL_CLOUSER_EARLY_TERMINATION_ID = '40204019';
	public static APPOINTMENT_CONFIRMED_AT_THE_OFFICE = 'APPOINTMENT_CONFIRMED_AT_THE_OFFICE';

    /* public static readonly ZIP_FILE_NAME = 'Foto.zip';

    public readonly BLOB_TYPE_FOR_ZIP = 'jpg';
    public readonly EXTENSION_TYPE_ZIP = '.zip'; */

    closure_type: string;
    color: string;
    company: string;
    contract_closure: string;
    contract_closure_insertion: string;
    contract_duration: string;
    contract_expiration: string;
    contract_number: string;
    contract_type: string;
    sales_force_number: string;
    leasing_company_id: string;
    make: string;
    model: string;
    nature: string;
    no_show_message: string;
    plate: string;
    state: string;
    state_id: number;
    driver: ContractDriverModel;
    surveyor: string;
    succeeding_contract_number: string;
    deductibleDamageFromNegligence: DeductibleDamage; // TODO:
    deductibleDamageNotReported: DeductibleDamage;
    deductibleDamageReported: DeductibleDamage;
    deductibleTotal: DeductibleDamage;
    checks_pre_evaluation: CheckPreEvaluationModel[] = [];
    service_point: ContractServicePointModel;
    tyres_general_data: TyresGeneralDataModel;
    wear_condition: SurveyWearConditionModel;
    relief: string;
    insurance_coverage: string;
    areChecksReady = false;
    areChecksOpened = false;
    attachments: AttachedContractModel[];
    rebillable_email_outcomes: RebillableEmailOutcomesModel[];
    termination_reason: string;
    //attachmentZipped: AttachedContractModel[] = [];
    customer: CustomerContractModel;
    adz = {} as ADZ;
    adzPartCostUpdated: boolean;
    rebillable_data = {} as CalculateReturn;
	pick_up_office_address?: OfficeAddressModel;
	pick_up_at_the_office?: OfficeDerogationModel;
	poolfleet_exception?: IPoolFleetException;
    insurance_type: keyof typeof InsuranceTypeEnum;
    po_number: string;
    headquarter: boolean;
    home_closing: boolean;
    reactive: boolean;
    po_excluded_for_product_id: string = '';
    po_center_address: string = '';
    po_km_distance: string = '';
    delivery_type?: string = '';

    static getStateID(state: string): number {
        switch (state) {
            case ContractDetailsModel.APPOINTMENT_REQUIRED:
                return ContractDetailsModel.APPOINTMENT_REQUIRED_ID;
            case ContractDetailsModel.APPOINTMENT_CONFIRMED:
                return ContractDetailsModel.APPOINTMENT_CONFIRMED_ID;
            case ContractDetailsModel.READY_FOR_SURVEY:
                return ContractDetailsModel.READY_FOR_SURVEY_ID;
            case ContractDetailsModel.WITH_SURVEY:
                return ContractDetailsModel.WITH_SURVEY_ID;
            case ContractDetailsModel.CLOSED:
                return ContractDetailsModel.CLOSED_ID;
            case ContractDetailsModel.REBILLABLE:
                return ContractDetailsModel.REBILLABLE_ID;
            case ContractDetailsModel.REBILLABLE_IN_WORKING:
                return ContractDetailsModel.REBILLABLE_IN_WORKING_ID;
            case ContractDetailsModel.REBILLABLE_IN_REVIEW:
                return ContractDetailsModel.REBILLABLE_IN_REVIEW_ID;
            case ContractDetailsModel.REBILLABLE_CLOSED:
                return ContractDetailsModel.REBILLABLE_CLOSED_ID;
            case ContractDetailsModel.NO_SHOW:
                return ContractDetailsModel.NO_SHOW_ID;
        }
    }

    static getTerminationReasonDescription(id: string) {
        switch (id) {
            case ContractDetailsModel.TOTAL_LOSS_ID:
                return ContractDetailsModel.TOTAL_LOSS;
            case ContractDetailsModel.VETTURA_DIFFORME_ID:
                return ContractDetailsModel.VETTURA_DIFFORME;
            case ContractDetailsModel.MODULO_CONTRATTO_SCADUTO_ID:
                return ContractDetailsModel.MODULO_CONTRATTO_SCADUTO;
            case ContractDetailsModel.PAYMENT_DEFAULT_OR_BANKRUPTCY_ID:
                return ContractDetailsModel.PAYMENT_DEFAULT_OR_BANKRUPTCY;
            case ContractDetailsModel.THEFT_ID:
                return ContractDetailsModel.THEFT;
            case ContractDetailsModel.FAILURE_ID:
                return ContractDetailsModel.FAILURE;
            case ContractDetailsModel.POOL_MIDTERM_ID:
                return ContractDetailsModel.POOL_MIDTERM;
            case ContractDetailsModel.RIENTRO_DA_FURTO_ID:
                return ContractDetailsModel.RIENTRO_DA_FURTO;
            case ContractDetailsModel.RIENTRO_DA_FALLIMENTO_ID:
                return ContractDetailsModel.RIENTRO_DA_FALLIMENTO;
            case ContractDetailsModel.APPROPRIAZIONI_INDEBITE_ID:
                return ContractDetailsModel.APPROPRIAZIONI_INDEBITE;
            case ContractDetailsModel.RIENTRO_APPROPRIAZIONI_INDEBITE_ID:
                return ContractDetailsModel.RIENTRO_APPROPRIAZIONI_INDEBITE;
            case ContractDetailsModel.CONTRATTO_SCADUTO_MECCANICA_ID:
                return ContractDetailsModel.CONTRATTO_SCADUTO_MECCANICA;
            case ContractDetailsModel.NORMAL_CLOUSER_EARLY_TERMINATION_ID:
                return ContractDetailsModel.NORMAL_CLOUSER_EARLY_TERMINATION;
            default:
                return '';
        }

    }

    constructor(model?: any) {
        this.attachments = [];
        if (!Utilities.isVoid(model)) {
            this.make = model.make;
            this.model = model.model;
            this.nature = model.nature;
            this.color = model.color;
            this.plate = model.plate;
            this.company = model.company;
            this.leasing_company_id = model.leasing_company_id;
            this.state = model.state;
            this.state_id = ContractDetailsModel.getStateID(this.state);
            this.driver = new ContractDriverModel(model.driver);
            this.surveyor = model.surveyor;
            this.contract_number = model.contract_number;
            this.contract_type = model.contract_type;
            this.sales_force_number = model.sales_force_number;
            this.succeeding_contract_number = model.succeeding_contract_number;
            this.contract_expiration = model.contract_expiration;
            this.contract_closure = model.contract_closure;
            this.contract_closure_insertion = model.contract_closure_insertion;
            this.contract_duration = model.contract_duration;
            this.no_show_message = model.no_show_message;
            this.deductibleDamageFromNegligence = model.deductibleDamageFromNegligence;
            this.deductibleDamageNotReported = model.deductibleDamageNotReported;
            this.deductibleDamageReported = model.deductibleDamageReported;
            this.deductibleTotal = model.deductibleTotal;
            this.adz = model.adz;
            this.adzPartCostUpdated = model.adz_part_cost_updated;
            this.rebillable_data = model.rebillable_data;
            this.deductibleDamageFromNegligence = model.deductibleDamageFromNegligence;
            this.deductibleDamageNotReported = model.deductibleDamageNotReported;
            this.deductibleDamageReported = model.deductibleDamageReported;
            this.rebillable_email_outcomes = model.rebillable_email_outcomes;
            this.termination_reason = model.termination_reason;
			this.pick_up_office_address = model.pick_up_office_address;
			this.pick_up_at_the_office = model.pick_up_at_the_office;
			this.poolfleet_exception = model.poolfleet_exception;
			this.insurance_type = model.insurance_type || InsuranceTypeEnum.STANDARD;
            this.tyres_general_data = model.tyres_general_data;
            this.po_number = model.po_number;
            this.headquarter = model.headquarter;
            this.home_closing = model.home_closing;
            this.reactive = model.reactive;
            this.po_excluded_for_product_id = model.po_excluded_for_product_id;
            this.po_center_address = model.po_center_address;
            this.po_km_distance = model.po_km_distance;

            if (!Utilities.isVoid(model.checks_pre_evaluation)) {
                for (const check of model.checks_pre_evaluation) {
                    const checkPreEvaluation = new CheckPreEvaluationModel(check);
                    checkPreEvaluation.update_status.subscribe(() => {
                        this.areChecksReady = this.setAreChecksReady();
                        // setTimeout(() => {
                        //     this.areChecksOpened = !this.areChecksReady;
                        // }, 1000);
                    });
                    this.checks_pre_evaluation.push(checkPreEvaluation);
                }
            }
            this.service_point = new ContractServicePointModel(model.service_point);
            this.closure_type = model.closure_type;
            this.wear_condition = new SurveyWearConditionModel(model.wear_condition);
            this.delivery_type = model.delivery_type || '';

            this.relief = model.relief;
            this.insurance_coverage = model.insurance_coverage;
            this.areChecksReady = this.setAreChecksReady();

            if (!Utilities.isVoid(model.attachments)) {
                for (const attached of model.attachments) {
                    this.attachments.push(new AttachedContractModel(attached));
                }
            }

            if (!Utilities.isVoid(model.customer)) {
                this.customer = new CustomerContractModel(model.customer);
            } else {
                this.customer = new CustomerContractModel().from(this.driver);
            }
        }
    }


    /* public splitAttachForZip() {
        this.attachmentZipped = this.attachments.filter(a => a.blob_type === this.BLOB_TYPE_FOR_ZIP);
        this.attachments = this.attachments.filter(a => a.blob_type !== this.BLOB_TYPE_FOR_ZIP);
        if (this.attachmentZipped.length > 0) {
            const zipFile = new AttachedContractModel();
            zipFile.file_name = ContractDetailsModel.ZIP_FILE_NAME;
            zipFile.blob_type = this.EXTENSION_TYPE_ZIP;
            zipFile.description = 'Raccolta di foto'
            this.attachments.push(zipFile);
        }
    } */

    getBody(): any {
        const checksPreEvaluation = [];
        for (const check of this.checks_pre_evaluation) {
            checksPreEvaluation.push(check.getBody());
        }
        return {
            model: this.model,
            plate: this.plate,
            company: this.company,
            state: this.state,
            driver: this.driver,
            surveyor: this.surveyor,
            contract_number: this.contract_number,
            sales_force_number: this.sales_force_number,
            succeeding_contract_number: this.succeeding_contract_number,
            contract_expiration: this.contract_expiration,
            contract_closure: this.contract_closure,
            contract_closure_insertion: this.contract_closure_insertion,
            service_point: this.service_point,
            closure_type: this.closure_type,
            relief: this.relief,
            insurance_coverage: this.insurance_coverage,
            delivery_type: this.delivery_type,
            wear_condition: this.wear_condition.getBody(),
            checks_pre_evaluation: checksPreEvaluation,
            attachments: this.attachments,
            signer: this.customer.getBody()
        }
    }

    public setAreChecksReady(): boolean {
        
        for (const check of this.checks_pre_evaluation) {
            if (!check.isReady) {
                return false;
            }
        }
        return true;
    }

}

export interface ClaimListChangeLogInstance {
	
    operationUser: string,
    note:          string,
    contract:      string,
    adzPartCostListData: {
        value_pre_update:  number,
        value_post_update: number,
        part_description:  string,
        difference_value:  number,
    }[]
}

export interface TyresGeneralDataModel {
	
    contract_tyre_summer: string,
    contract_tyre_winter: string,
    count_damage_pneu: number,
    deposit_tyre_summer: number,
    deposit_tyre_winter: number,
    description_tyre_summer_available: string,
    description_tyre_winter_available: string,
    residual_contract_tyre_summer: number,
    residual_contract_tyre_winter: number,
    total_contract_tyre: string,
    total_deposit_tyre: string,
    total_residual: string,
}

export enum TyresGeneralSpecialDataEnum {
    ILLIMITATO = "ILLIMITATO",
    ESAURITI = "ESAURITI",
    A_CONSUMO = "A consumo",
    DISPONIBILI = "DISPONIBILI"
}

export enum InsuranceTypeEnum {
    STANDARD = 'STANDARD',   // contratto ordinario già in uso
    SELF = 'SELF',           // AUTOASSICURAZIONE - nuovo tipo di contratto
    MIX = 'MIX',             // MISTI             - nuovo tipo di contratto
    TWOLTOP = 'TWOLTOP',     // SECOND_LIFE_TOP   - nuovo tipo di contratto
    TWOLMIX = 'TWOLMIX',     // SECOND_LIFE_MISTI - nuovo tipo di contratto
  }

export const TypeDeductibleDamageFranchise = 'franchise';
export const TypeDeductibleDamageForfait = 'forfait';
export const TypeDeductibleDamageExemption = 'exemption';
export const TypeDeductibleDamageAdHoc = 'adhoc';

export interface DeductibleDamage {
    type: string;
    description: string;
    value: number;
}

export interface TokenListZip {
    access_token: string;
    expires_at: number;
}

export interface ADZ {
    rows: Row[];
}

export interface Row {

    type: string;
    id_report: string;
    plate: string;
    frame: string;
    brand: string;
    model: string;
    version: string;
    part: string;
    sequence: string;
    flag: string;
    fiscal_code: string;
    date_accident: string;
    number_accident: string;
    agency_code: string;
    vehicle_type: string;
    part_code: string;
    part_type: string;
    part_code2: string;
    part_description: string;
    print_part_code: string;
    sr_time: string;
    la_time: string;
    ve_time: string;
    me_time: string;
    part_cost: string;
    sr_level: string;
    la_level: string;
    ve_level: string;
    grouping_code: string;
    percentage_on_parts: string;
    control_flag_sr: string;
    control_flag_la: string;
    control_flag_ve: string;
    control_flag_Me: string;
    control_flag_part_cost: string;
    left_right: string;
    percentage_gap: string;
    filler_ania: string;
    filler_software_housestring: string;
    repaired_by_ald: boolean;
}

export class ContractServicePointModel {
    ald_supplier_id: string;
    ald_supplier_label: string;
    ald_supplier_code: string;


    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.ald_supplier_id = model.ald_supplier_id;
            this.ald_supplier_label = model.ald_supplier_label;
            this.ald_supplier_code = model.ald_supplier_code;
        }
    }
}

export interface RebillableEmailOutcomesModel {
    outcome: string;
    recipients: string[];
    datetime_sent: string;
}

export class ContractDriverModel {
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
    main_address: ContractDriverMainAddressModel;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.phone = model.phone;
            this.email = model.email;
            this.first_name = model.first_name;
            this.last_name = model.last_name;
            this.main_address = new ContractDriverMainAddressModel(model.main_address);
        }
    }
}

export class ContractDriverMainAddressModel {
    city: string;
    zip: string;
    street: string;
    street_nr: string;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.city = model.city;
            this.zip = model.zip;
            this.street = model.street;
            this.street_nr = model.street_nr;
        }
    }
}

export class SurveyWearConditionModel {

    static SURVEY_STATUS_EXTERNAL = 'SURVEY_STATUS_EXTERNAL';
    static SURVEY_STATUS_INTERNAL = 'SURVEY_STATUS_INTERNAL';
    static SURVEY_STATUS_END = 'SURVEY_STATUS_END';

    mileage: string;
    surveyor_note: string;
    customer_note: string;
    vehicle_state: string;
    inspection_value: string;

    date: string;

    internal_damages: SurveyDamageModel[];
    external_damages: SurveyDamageModel[];
    tire_conditions: TireCondition[];

    constructor(model?: any) {
        this.internal_damages = [];
        this.external_damages = [];
        this.tire_conditions = [];
        if (!Utilities.isVoid(model)) {
            this.mileage = model.mileage;
            this.surveyor_note = model.surveyor_note;
            this.customer_note = model.customer_note;
            this.vehicle_state = model.vehicle_state;
            this.inspection_value = model.inspection_value;

            this.date = model.date;

            if (!Utilities.isVoid(model.internal_damages)) {
                for (const damage of model.internal_damages) {
                    this.internal_damages.push(new SurveyDamageModel(damage));
                }
            }

            if (!Utilities.isVoid(model.external_damages)) {
                for (const damage of model.external_damages) {
                    this.external_damages.push(new SurveyDamageModel(damage));
                }
            }

            if (!Utilities.isVoid(model.tire_conditions)) {
                for (const tire of model.tire_conditions) {
                    this.tire_conditions.push(tire as TireCondition);
                }
            }
        }
    }

    getBody(): any {
        const internalDamages = [];
        for (const damage of this.internal_damages) {
            internalDamages.push(damage.getBody());
        }

        const externalDamages = [];
        for (const damage of this.external_damages) {
            externalDamages.push(damage.getBody());
        }

        return {
            mileage: this.mileage,
            surveyor_note: this.surveyor_note,
            customer_note: this.customer_note,
            vehicle_state: this.vehicle_state,
            inspection_value: this.inspection_value,
            date: this.date,
            internal_damages: internalDamages,
            external_damages: externalDamages,
            tire_conditions: this.tire_conditions
        }
    }
}

export class SurveyDamageModel {
    static VALUE_NUMBER = 4;

    static PART_FIELD = 0;
    static POSITION_FIELD = 1;
    static ISSUE_FIELD = 2;
    static SEVERITY_FIELD = 3;


    part = '';
    issue = '';
    position = '';
    severity = '';
    reenteredDate: string;
    id: string;

    validationStates = new Array(SurveyDamageModel.VALUE_NUMBER).fill(false);

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.id = model.id;
            this.part = model.part;
            this.issue = model.issue;
            this.position = model.position;
            this.severity = model.severity;
            this.reenteredDate = model.reenteredDate;
            this.id = model.id;
            this.setValidations();
        }
    }


    isEmpty(): boolean {
        return this.part === '' && this.issue === ''
            && this.position === '' && this.severity === '';
    }

    isValid(): boolean {
        return !this.validationStates.includes(false);
    }

    getBody() {
        return {
            id: this.id,
            part: this.part,
            issue: this.issue,
            position: this.position,
            severity: this.severity,
            reenteredDate: this.reenteredDate
        }
    }

    setValidations() {
        this.validationStates[SurveyDamageModel.PART_FIELD] = !Utilities.isVoid(this.part) && Utilities.escapeSpecialChart(this.part).length > 0;
        this.validationStates[SurveyDamageModel.POSITION_FIELD] = this.validationStates[SurveyDamageModel.POSITION_FIELD];
        this.validationStates[SurveyDamageModel.ISSUE_FIELD] = this.validationStates[SurveyDamageModel.ISSUE_FIELD] && !Utilities.isVoid(this.issue) && Utilities.escapeSpecialChart(this.issue).length > 0;
        this.validationStates[SurveyDamageModel.SEVERITY_FIELD] = this.validationStates[SurveyDamageModel.SEVERITY_FIELD] && !Utilities.isVoid(this.severity) && Utilities.escapeSpecialChart(this.severity).length > 0;
    }
}

export interface TireCondition {

    brand: string;
    type: string;
    seasonality: string;
    width: string;
    radius: string;
    load_index: string;
    ratio: string;
    velocity_code: string;

    position: string;
    side: string;
    axis: string;
    type_of_damage: string;
    external_thread: string;
    internal_thread: string;
    center_thread: string;
    notes: string;
}

export class AttachedContractModel {
    uuid: string;
    file_name: string;
    blob_name: string;
    file_size: string;
    mime_type: string;
    blob_type: string;
    description: string;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.uuid = model.uuid;
            this.file_name = model.file_name;
            this.blob_name = model.blob_name;
            this.blob_type = model.blob_type;
            this.file_size = model.file_size;
            this.mime_type = model.mime_type;
            this.blob_name = model.blob_name;
            this.description = model.description;
        }
    }
}

export class CustomerContractModel {
    fiscal_code: string;
    name: string;
    surname: string;
    date_of_birth: string;
    gender: string;
    birth_place: string;
    email: string;
    phone: string;
    address: string;
    address_number: string;
    zip_code: string;
    city: string;
    license_issue_country: string;
    license_number: string;
    license_by: string;
    license_release: string;
    license_validity: string;
    prefix_phone: string;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.fiscal_code = model.fiscal_code;
            this.name = model.name;
            this.surname = model.surname;
            this.date_of_birth = model.date_of_birth;
            this.gender = model.gender;
            this.birth_place = model.birth_place;
            this.email = model.email;
            this.phone = model.phone;
            this.address = model.address;
            this.address_number = model.address_number;
            this.zip_code = model.zip_code;
            this.city = model.city;
            this.license_issue_country = model.license_issue_country;
            this.license_number = model.license_number;
            this.license_by = model.license_by;
            this.license_release = model.license_release;
            this.license_validity = model.license_validity;
            this.prefix_phone = model.prefix_phone
        }
    }

    setByForm(model: any) {
        if (!Utilities.isVoid(model)) {
            this.fiscal_code = Utilities.isVoid(model.fiscal_code) ? '' : model.fiscal_code.toUpperCase();
            this.name = model.name;
            this.surname = model.surname;
            this.date_of_birth = model.date_of_birth;
            this.gender = Utilities.isVoid(model.gender) ? '' : model.gender.toUpperCase();
            this.birth_place = model.birth_place;
            this.email = model.email;
            this.phone = model.phone;
            this.address = model.address;
            this.address_number = model.address_number;
            this.zip_code = model.zip_code;
            this.city = model.city;
            this.license_issue_country = model.license_issue_country;
            this.license_number = model.license_number;
            this.license_by = model.license_by;
            this.license_release = model.license_release;
            this.license_validity = model.license_validity;
            this.prefix_phone = model.prefix_phone;
        }
    }

    getBody() {
        const body = new CustomerContractModel(this);
        if (CountriesListModel.getIsoCountryName(body.license_issue_country).length === 0) {
            body.license_issue_country = CountriesListModel.getIsoCountryCode(this.license_issue_country);
        }
        return body;
    }

    from(driver: ContractDriverModel): CustomerContractModel {
        if (!Utilities.isVoid(driver)) {
            this.name = driver.first_name;
            this.surname = driver.last_name;
            this.email = driver.email;
            this.phone = driver.phone;
            if (!Utilities.isVoid(driver.main_address)) {
                this.address = driver.main_address.street;
                this.address_number = driver.main_address.street_nr;
                this.zip_code = driver.main_address.zip;
                this.city = driver.main_address.city;
            }
        }
        return this;
    }

}

interface IPoolFleetException {
    code:    string
    message: string
}


export enum ECCDeliveryType {
	HOME_CLOSING = 'home_closing',
	HEADQUARTER  = 'headquarter',
}